<div class="backend-error-container">
  <div class="error-card">
    
    <h1 class="error-title">Service Unavailable</h1>

    <p class="error-message">
      We are sorry, our backend service is not responding at the moment.
    </p>

    <p class="error-submessage">
      Please wait a moment and try refreshing the page.
    </p>

    <cm-ui-standard-button roundedGray (onClick)="refreshPage()" icon="refresh">
      Refresh Page
    </cm-ui-standard-button>

    <div class="error-details">
      <p>If the problem persists, please contact your system administrator.</p>
    </div>
  </div>
</div>
